<template>
  <div v-if="isLoaded">
    <div class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document" :class="isTypeCatalog?'folder-modal':'file-modal'">
        <div class="modal-content" :class="{'form-view-active': viewMode === 'form' && !isTypeCatalog}">
          <div class="modal-header p-2" style="height:64px">
            <h5 class="modal-title">
              {{$t('Tag Metadata')}}
              <span v-if="fileInfo && fileInfo.archived" class="header-title-separator">|</span>
              <svg v-if="fileInfo && fileInfo.archived" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill archived-header-icon" viewBox="0 0 16 16">
                <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path>
                <title>{{$t('Archived')}}</title>
              </svg>
            </h5>
            <div class="d-flex align-items-center">
              <ConfigureButtons v-if="!isTypeCatalog" componentId="FA-tagmetadata_fullscreen_on_asset_headerbar" 
              :imageStyles="{ height: '21px !important', width: '21px !important', marginRight: '0px !important' }" 
              :buttons="getComponentSpecificButton('FA-tagmetadata_fullscreen_on_asset_headerbar')" 
              :ruleData="assetDetails"
              :disableAfterClick="true"
              @button-click="handleButtonClick" style="position:relative;bottom: 6px;"></ConfigureButtons>
              <div class="dropdown  close-icon" v-if="isUserTypeAdministrator() && !isTypeCatalog" style="top:-7px;height: 30px;width: 30px;display: flex;align-items: center;justify-content: center;left: 2px;">
                  <svg xmlns="http://www.w3.org/2000/svg"  width="20" height="20" fill="#b1b1b1" class="bi bi-three-dots-vertical dropdown-toggle" viewBox="0 0 16 16" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="metadata-options-dropdown">
                    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
                  </svg>
            
                <div class="dropdown-menu dropdown-menu-right metadata-options-menu" style="margin-top: -13px;" @click="clickToOpenButtonsBrowse('FA-tagmetadata_fullscreen_on_asset_headerbar')" aria-labelledby="metadata-options-dropdown">
                  <button type="button" class="dropdown-item">
                    {{$t('Configure Buttons')}}
                  </button>
                </div>
              </div>
              <div class="view-switch-wrapper" v-if="!isTypeCatalog">
                <span
                  v-if="viewMode === 'compact'"
                  v-on:click="setViewMode('form')"
                  class="view-switch-icon"
                  :title="$t('Switch to form view')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-list-ul" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                  </svg>
                </span>
                <span
                  v-else
                  v-on:click="setViewMode('compact')"
                  class="view-switch-icon"
                  :title="$t('Switch to compact view')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-menu-button-wide" viewBox="0 0 16 16">
                    <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v2A1.5 1.5 0 0 1 14.5 5h-13A1.5 1.5 0 0 1 0 3.5zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z"/>
                    <path d="M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m10.823.323-.396-.396A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0M0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"/>
                  </svg>
                </span>
              </div>
              <div v-if="!isTypeCatalog" style="border: 1px solid #3a3a3a;width: 2px;height: 30px;position: relative;top: -6px;background: #3a3a3a;margin: 0px 10px;left: 4px;"></div>
              <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" v-on:click="closeMetadataManager" style="position: relative;top: -6px;">
                <span aria-hidden="true">
                    <cancel-icon class="close-icon" style="height: 40px !important;
                        width: 40px !important;
                        color: #fff;">
                    </cancel-icon>
                  </span>
              </button>
            </div>
          </div>
          <div class="modal-body row">
            <div v-if="!isTypeCatalog" class="col-md-6 selected-thumbnail-display h-100 p-1 m-0">
                <div class="w-100" style="height:55%;display:flex;justify-content:center;position:relative">
                   <template v-if="isVideoFile">
                      <div style="height:100%;width:100%;display:inline-block">
                          <video-player ref="videoPlayerRef" id="video-player-id" @controller="setController" :isCurrentTimeUpdateRequired="true" :isProgressbarRequired="true" :options="videoOptions" @metaDataLoaded="videoPlaytoggle" style="height:100%;width:100%"/>
                      </div>
                  </template>
            <!--       <audio v-if="isAudioFile" id="audio-player-id" class="audio-player" controls="controls" controlslist="nodownload">
                      <source :src="audioUrl" type="audio/mpeg" />
                  </audio> -->
                  <customAudioPlayer :key="getAudioParentAsset && getAudioParentAsset._id"  @playerPaused="isPlaying = false" @audioStartedPlaying="isPlaying = true" ref="audioPlayerRef" :isPlayButtonRequired="false" :fileInfo="getAudioParentAsset" class="audio-player" style="bottom: 33px;" v-if="isAudioFile" :subclipDetails="subclipDetails"></customAudioPlayer>
                  <!-- <embed v-if="!isVideoFile" src="http://www.pdf995.com/samples/pdf.pdf" alt="pdf" style="height:100%;width:100%" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html"> -->
                  <img v-if="isImageFile || isAudioFile" :style="isAudioFile ? 'padding: 55px;top: 37%;':''" :src="getThumbnailPath(assetDetails)" @error="replaceByDefaultImage">
                </div>
                <div v-if="isVideoFile || isAudioFile" id="palyer_icons_wrapper">
                  <ul>
                      <li title="Toggle Play-Pause (spacebar)" style="width:90px"><button style="width: 90px; display: flex; align-items: center;justify-content:center;" class="btn btn-outline-secondary play common-markinmarkout-action-btn" @click="playPauseToggle()">  <span v-show="isPlaying" class="common-play-pause"><svg style="width:18px;height:18px;margin-top:1px !important" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg> <span style="margin-inline-start: -3px;">Pause</span> </span>   <!-- play button -->  <span v-show="!isPlaying" class="common-play-pause"><svg  style="width:18px;height:18px;;margin-top:1px !important" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M10 8.64L15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z"/></svg><span>Play</span><span style="visibility:hidden;"></span></span> </button></li>
                      <li title="Backward 1 Second (9)"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="forwardBackwardVideoBy1Sec('backward')">-1S</button></li>
                      <li title="Forward 1 Second (0)"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="forwardBackwardVideoBy1Sec('forward')">+1S</button></li>
                      <li title="Backward 1 Frame (-)"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="forwardBackwardVideoByFrame('backward')">-1F</button></li>
                      <li title="Forward 1 Frame (=)"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="forwardBackwardVideoByFrame('forward')">+1F</button></li>
                      <li title="Fast Forward" style="margin-inline-end:6px;width:50px"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="updateFastwardValue('forward')" style="width:50px;">FF</button></li>
                      <li v-if="currentVideoSpeed != 1" style="display: flex;align-items: center;color: #bcbcbc;margin-inline-start: 3px;">
                          <span style="border: 1px solid #4a4a4a !important;border-radius: 15px !important;width: 40px;padding: 4px;text-align: center;font-size: 14px;background: #282d31 !important;">{{currentVideoSpeed}}x</span></li>
                  </ul>
                  <!-- <div class="fast-backward-div comm-forward-icon" @click="updateBackwardValue()" :disabled="currentVideoSpeed<=1?true:false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-skip-backward" viewBox="0 0 16 16">
                      <path d="M.5 3.5A.5.5 0 0 1 1 4v3.248l6.267-3.636c.52-.302 1.233.043 1.233.696v2.94l6.267-3.636c.52-.302 1.233.043 1.233.696v7.384c0 .653-.713.998-1.233.696L8.5 8.752v2.94c0 .653-.713.998-1.233.696L1 8.752V12a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm7 1.133L1.696 8 7.5 11.367V4.633zm7.5 0L9.196 8 15 11.367V4.633z"/>
                      <title>Fast backward </title>
                    </svg>
                  </div>
                  <div class="fast-forward-div comm-forward-icon" @click="updateFastwardValue()" :disabled="currentVideoSpeed>=5?true:false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-skip-forward" viewBox="0 0 16 16">
                      <path d="M15.5 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V8.752l-6.267 3.636c-.52.302-1.233-.043-1.233-.696v-2.94l-6.267 3.636C.713 12.69 0 12.345 0 11.692V4.308c0-.653.713-.998 1.233-.696L7.5 7.248v-2.94c0-.653.713-.998 1.233-.696L15 7.248V4a.5.5 0 0 1 .5-.5zM1 4.633v6.734L6.804 8 1 4.633zm7.5 0v6.734L14.304 8 8.5 4.633z"/>
                    </svg>
                    <title>Fast forward</title>
                  </div> -->
                  <div class="reset-btn comm-forward-icon" style="float:rght" @click="resetVideoSpped">
                    <span>Reset</span>
                  </div>
                  <div v-if="isVideoFile" class="reset-btn comm-forward-icon" style="float:rght" @click="captureThumbnailFromVideo()">
                    <span>Capture</span>
                  </div>
                </div>
                <div class="assets-details-in-metadata-manager" :style="!isVideoFile?{'height':'calc(100% - 57%)'}:{'height':'calc((100% - 57%) - 48px)'}">
                  <div
                        v-if="isImageFile || isVideoFile"
                        class="text-left"
                        style="padding: 10px 0px 10px 8px; color: #777"
                    >
                      <svg  v-if="!showCaptureThumbnail" v-on:click="showCaptureThumbnail = true" style="float:unset;margin-top:unset;margin-inline-end:3px" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                          <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                      </svg>
                      <svg v-if="showCaptureThumbnail" v-on:click="showCaptureThumbnail = false" style="float:unset;margin-top:unset;margin-inline-end:3px" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                          <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                      </svg>
                        <span style="position:relative;inset-inline-start:1px;top:2px;font-size: 18px;">Thumbnail</span>
                  </div>
                  <div v-if="(isImageFile || isVideoFile) && showCaptureThumbnail" style="display:flex;justify-content:center">
                    <div class="thumbanils-display">
                      <div class="generated-thumbails" @click="activeThumbnail = 'primaryThumbnail'" :class="{activeDiv: activeThumbnail === 'primaryThumbnail'}">
                        <img v-if="primaryThumbnailUrl || primaryCanvasImage" :src="getProxyConvertedURL(primaryThumbnailUrl)" @error="replaceByDefaultImage" style="height:100%;width:100%;object-fit: contain;" class="unselected-image"/>
                        <!-- don't show canvas now by display:none; -->
                        <canvas id="primaryThumbanilCanvas" v-if="primaryCanvasImage" style="height:100%;width:100%;display:none;" class="unselected-image"></canvas>
                        <div v-if="activeThumbnail == 'primaryThumbnail'" class="tick-mark-on-thumbnail">
                          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#eee" class="bi bi-check2 mt-0" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"></path>
                          </svg>   
                        </div>
                        <div class="thumbnail-type-tag">{{$t('Primary')}}</div>
                        <div class="on-hover-icons">
                           <div style="position:relative">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-crop" viewBox="0 0 16 16" @click="openCaptureThumbnailDialog('primary')">
                                      <path d="M3.5.5A.5.5 0 0 1 4 1v13h13a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2H3.5a.5.5 0 0 1-.5-.5V4H1a.5.5 0 0 1 0-1h2V1a.5.5 0 0 1 .5-.5m2.5 3a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4H6.5a.5.5 0 0 1-.5-.5"/>
                                      <title>{{$t('Crop thumbnail')}}</title>
                                </svg>
                            </div>
                          <div style="position:relative">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-upload" viewBox="0 0 16 16">
                              <title>Upload</title>
                              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                              <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z"/>
                            </svg>
                            <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                              <input 
                                  style="height:100%;width:100%"
                                  type="file"
                                  id="img" name="img" accept=".jpg,.jpeg,.png"
                                  ref="file"
                                  :title="$t('Upload thumbnail')"
                                  v-on:change="uploadThumbnail($event,'primary')"
                                />
                            </div>
                            </div>
                        </div>
                      </div>
        
                      <div class="custom-thumbanil" @click="activeThumbnail = 'SecondaryThumnail'" :class="{activeDiv: activeThumbnail === 'SecondaryThumnail', applyborder:!secondaryCanvasImage && !thumbnailUrl}">
                        <img v-if="thumbnailUrl || secondaryCanvasImage" @error="replaceByDefaultImage" :src="getProxyConvertedURL(thumbnailUrl)" style="height:100%;width:100%;object-fit: contain;" class="unselected-image"/>
                        <!-- don't show secondary canvas now by display none-->
                        <canvas id="secondaryThumbnailCanvas" v-if="secondaryCanvasImage" style="height:100%;width:100%;display:none;" class="unselected-image"></canvas>
                        <div class="d-inline-flex" v-if="!selectedConvasSecondaryImage && !thumbnailUrl">
                          <div style="padding:5px;margin-bottom:6px;display:flex;align-items:center">
                            <span class="secondary-btn-style" style="font-size:20px">{{$t('Secondary')}}</span>
                          </div>
                        </div>
                        <div v-if="activeThumbnail == 'SecondaryThumnail'" class="tick-mark-on-thumbnail">
                          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#eee" class="bi bi-check2 mt-0" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"></path>
                          </svg>   
                        </div>
                        <div v-if="secondaryCanvasImage || thumbnailUrl"  class="thumbnail-type-tag" style="background:orange;color:black">{{$t('Secondary')}}</div>
                        <div class="on-hover-icons">
                           <div style="position:relative">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-crop" viewBox="0 0 16 16" @click="openCaptureThumbnailDialog('secondary')">
                                      <path d="M3.5.5A.5.5 0 0 1 4 1v13h13a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2H3.5a.5.5 0 0 1-.5-.5V4H1a.5.5 0 0 1 0-1h2V1a.5.5 0 0 1 .5-.5m2.5 3a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4H6.5a.5.5 0 0 1-.5-.5"/>
                                      <title>{{$t('Crop thumbnail')}}</title>
                                </svg>
                            </div>
                          <div style="position:relative">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-upload" viewBox="0 0 16 16">
                              <title>{{$t('Upload')}}</title>
                              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                              <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z"/>
                            </svg>
                            <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                              <input 
                                  style="height:100%;width:100%"
                                  type="file"
                                  id="img" name="img" accept=".jpg,.jpeg,.png"
                                  ref="file"
                                  :title="$t('Upload thumbnail')"
                                  v-on:change="uploadThumbnail($event,'secondary')"
                                />
                            </div>
                          </div>
                        </div>
                        <!-- <div v-if="selectedConvasImage.length > 0" v-on:click.stop.prevent="updateGeneratedThumbnail('primaryThumbnail')"  v-on:click.stop.prevent="isChange = !isChange" style="position:absolute;top:0px;inset-inline-end:0px" class="replace-uploaded-thumbnail"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                            </svg>
                            <div v-if="isChange" v-on:click.stop.prevent="captureThumbnailFromVideo()" class="change-thumbnail">Capture again</div>
                        </div> -->
                          <!-- <div v-if="!isSecondaryThumnailUrl && !primaryCanvasImage" style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                              <input style="height:100%;width:100%" type="file" id="img" name="img" accept="image/*" ref="file" v-on:change="uploadThumbnail($event)"/>
                          </div> -->
                          <!-- <div v-if="isSecondaryThumnailUrl || primaryCanvasImage" v-on:click="isChange = !isChange" style="position:absolute;top:0px;inset-inline-end:0px" class="replace-uploaded-thumbnail"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                              <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                              </svg>
                              <div v-if="isChange" class="change-thumbnail">Change
                              <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                                              <input 
                                                  style="height:100%;width:100%"
                                                  type="file"
                                                  id="img" name="img" accept="image/*"
                                                  ref="file"
                                                  v-on:change="uploadThumbnail($event)"
                                                />
                                        </div>
                              </div>
                            </div>               -->
                      </div>
                    </div>
                  </div>
                  <div v-if="isVideoFile"
                        class="text-left"
                        style="padding: 10px 0px 10px 8px; color: #777"
                    >
                    <svg  v-if="!showBasicInfo" v-on:click="showBasicInfo = true" xmlns="http://www.w3.org/2000/svg" style="float:unset;margin-top:unset;margin-inline-end:3px" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                        <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                    </svg>
                    <svg v-if="showBasicInfo" v-on:click="showBasicInfo = false" xmlns="http://www.w3.org/2000/svg" style="float:unset;margin-top:unset;margin-inline-end:3px" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                        <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                    </svg>
                      <span style="position:relative;inset-inline-start:1px;top:2px;font-size: 18px;">Basic info</span>
                  </div>
                  <div v-show="showBasicInfo">
                    <ul>
                        <li>
                            <div class="key-style">Filename </div>
                            <div class="value-style" style="overflow-wrap:anywhere">{{getFileName(assetDetails)}}</div>
                        </li>
                        <li v-if="startUpInfo.enable_reference_id_workflow && Object.keys(assetDetails).includes('reference_id') &&
                        !['undefined',null].includes(assetDetails.reference_id) &&  assetDetails.reference_id.length > 0">
                          <div class="key-style">{{startUpInfo.alias &&  startUpInfo.alias.alias_name?startUpInfo.alias.alias_name:"Reference ID"}}</div>
                          <div class="value-style">{{assetDetails.reference_id}}</div>
                      </li>
                        <li>
                            <div class="key-style">Path</div>
                            <div class="value-style" style="overflow-wrap:anywhere">{{getFilePath(assetDetails)}}</div>
                        </li>
                        <li v-if="assetDetails.storage_class && assetDetails.storage_class.length">
                            <div class="key-style">Location</div>
                            <div class="value-style">
                              <div v-for="storageClass in assetDetails.storage_class" class="d-inline-flex" :key="storageClass">
                                <svg v-if='storageClass == "Disk"' xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16"><path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path><title>Archived</title></svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" :fill="getColorBasedOnExpiry(assetDetails.location_info,storageClass)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                </svg>
                                <span style="margin-inline-start:4px">{{ storageClass }}</span>
                              </div>
                            </div>
                        </li>
                        <li>
                            <div class="key-style">Date Added</div>
                            <div class="value-style">{{getDateAndTimeInConfiguredFormat(assetDetails.added_datetime)}}</div>
                        </li>
                        <li>
                            <div class="key-style">Date Created</div>
                            <div class="value-style">{{getDateAndTimeInConfiguredFormat(assetDetails.created_datetime)}}</div>
                        </li>
                        <li>
                            <div class="key-style">Size</div>
                            <div class="value-style">{{humaniseSize(assetDetails.size)}}</div>
                        </li>
                        <li v-if="'mime_type' in assetDetails && assetDetails.mime_type && assetDetails.mime_type.startsWith('video') &&
                          'duration' in assetDetails && assetDetails.duration">
                          <div class="key-style">Duration</div>
                          <div class="value-style">{{getHumanReadableDuration(assetDetails.duration)}}</div>
                        </li>
                    </ul>
                  </div>
                </div>
            </div>
            <div class="p-0 h-100 col-md-6 metadata-fields" :class="isTypeCatalog?'col-md-12':'col-md-6'" style="display:flex">
              <div style="width:100%;height:100%;display:flex;flex-direction:column">
                <tag-metadata
                  v-if="isTypeCatalog || viewMode === 'compact'"
                  ref="tagMetadataWindow" :fileInfo="fileInfo" v-bind="selectedAssetInfo" :displayMessage="displayMessage" :screenType="getScreenType"
                  :isMetadataDock="false" @setTranscriptData="setTranscriptData" :isTagMetadataDock="true" @openSubclipWindow="openSubclipWindow"
                  @playSubclipMarkinMarkout="playSubclipMarkinMarkout" :isVideoFile="isVideoFile" @navigateToAIComponent="handleAIComponentNavigation"></tag-metadata>
                  <TagMetadataCommonComponent
                  v-else
                  ref="tagMetadataCommonWindow"
                  style="height:100%;flex:1;min-height:0"
                  :fileInfo="fileInfo"
                  v-bind="selectedAssetInfo"
                  :displayMessage="displayMessage"
                  :screenType="getScreenType"
                  :isMetadataDock="false"
                  :isTagMetadataDock="true"
                  :isVideoFile="isVideoFile"
                  :enableSubclip="false"
                  @navigateToAIComponent="handleAIComponentNavigation"
                  @openSubclipWindow="openSubclipWindow"
                  @setTranscriptData="setTranscriptData"
                  @playSubclipMarkinMarkout="playSubclipMarkinMarkout"
                  parentComponent="tagMetadataFullScreen"
                  @updateAssetDeatils="updateAssetDeatils"
                ></TagMetadataCommonComponent>
              </div>
            </div>
        </div>
      </div>
      </div>
        <router-view 
          :name="selectedComponent" 
          :fileInfo="assetDetails"
          :selectedSubclip="selectedSubclip?selectedSubclip:{}"
          :ref="'modal'+selectedComponent">
        </router-view>
        <confirmMessageDialog
        v-if="openConfirmMessageDialog"
        :confirmMessage="confirmMessage"
        :confirmPanelTitle="$t('Please Confirm')"
        primaryButtonName="Yes"
        secondaryButtonName="No"
        @close="openConfirmMessageDialog = false"
        @primaryButtonAction="primaryButtonAction"
        @secondaryButtonAction="secondaryButtonAction"
        ></confirmMessageDialog>
        <ThumbnailCrop v-if="isThumbnailCaptureWithCrop" @closeCropDialog="isThumbnailCaptureWithCrop = false; cropThumbnailURL = ''" :imageUrl="getImageURL" :thumbnailType="activeThumbnail" @croppedBase64Data="handleCropImageData" :captureFrameTimeMMS="captureFrameTimeMMS"></ThumbnailCrop>
        <buttonsBrowse class="rendered-button-browse-dialog" style="z-index:999999 !important;" v-if="openButtonsBrowse" :configuredButtonsArray="configuredButtonsArray" :payloadFromParent="getPayloadToUpdateButton()" :alreadySelectedButtons="getComponentSpecificButton(selectedButtonComponent)" :selectedComponent="selectedButtonComponent" @close="openButtonsBrowse = false" @updateButtonsToComponents="updateButtonsToComponents"></buttonsBrowse>
    </div>
</div>
</template>
<script>
import VideoPlayer from "../core/VideoPlayer.vue";
import "vue2-datepicker/index.css";
import {mapActions, mapGetters,mapMutations} from "vuex";
import Utils from "../../components.utils.js"
import tagMetadataComponent from "./TagMetadataComponent.vue"
import RangeSliderMixins from '../../mixins/RangeSliderMixin.js';
import {NotifierConstants} from "../../components.constants.js";
import subclipPreviewMixin from '../../mixins/SubclipPreviewMixin.js';
import CancelIcon from "../core/InlineCancelField.vue";
import customAudioPlayer from '../customAudioPlayer/AudioPlayerComponent.vue';
import confirmMessageDialog from "../miscellaneous/confirmMessageDialog.vue";
import ThumbnailCrop from "../core/Crop.vue";
import ConfigureButtons from "../ButtonsConfiguration/ConfiguredButtons.vue";
import ButtonsBrowse from "../ButtonsConfiguration/ButtonsBrowse.vue";
import TagMetadataCommonComponent from "./TagMetadataCommonComponent.vue";

const TAG_METADATA_VIEW_MODE_KEY = 'tagMetadataViewMode';

export default {
  name:"tagMetadata",
  mixins:[RangeSliderMixins,subclipPreviewMixin],
  data() {
    return {
      viewMode: (function(){
        try{
          return localStorage.getItem(TAG_METADATA_VIEW_MODE_KEY) || 'compact';
        }catch(e){
          console.log(e);
          return 'compact';
        }
      })(), // 'compact' | 'form' — restored from localStorage, defaults to 'compact'
      subclipDetails:null,
      audioPlayerFileInfo:null,
      isThumbnailCaptureWithCrop:false,
      cropThumbnailURL:'',
      captureFrameTimeMMS:null,
      transcriptObject:null,
      fileInfo:{},
      isLoaded:false,
      assetId:null,
      time:null,
      assetDetails:{},
      route:"",
      editingMetacomponente:"",
      actionsOnPlayer: false,
      audioUrl:null,
      controller:{},
      selectedComponent:null,
      selectedSubclip:null,
      parentRouteInfo:{},
      currentVideoSpeed : 1,
      isPlaying: false,
      enableProjectsField:false,
      videoOptions: {
                autoplay: false,
                controls: true,
                nativeTextTracks: true,
                controlBar:{
                        'pictureInPictureToggle': false,
                        'progressControl': true,
                        'remainingTimeDisplay': false,

                    volumePanel: {
                        inline: false,
                        vertical: true
                    },

                    playToggle: false
                },
                preload: "metadata", //loadmetadata such as duration required for range slider, won't load whole video
                sources: []
			},
      displayMessage:null,
      showCaptureThumbnail:true,
      showBasicInfo:true,
      isSecondaryThumnailUrl:false,
      selectedConvasImage:'',
      uploadedCustomThumbnail:'',
      primaryCanvasImage:false,
      secondaryCanvasImage:false,
      isChange:false,
      selectedDepartments:null,
      thumbnailUrl:null,
      primaryThumbnailUrl:null,
      activeThumbnail:"primaryThumbnail",
      openConfirmMessageDialog:false,
      uploadedCustomThumbnailForSecondaryImage:'',
      uploadedCustomThumbnailForPrimaryImage:'',
      selectedConvasSecondaryImage:null,
      selectedConvasPrimaryImage:null,
      svgIconForStorageClass:{"Amazon S3 Glacier":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-fill" viewBox="0 0 16 16"><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/></svg>',
                                    "Amazon S3 Glacier Instant Retrieval":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill" viewBox="0 0 16 16"><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/></svg>',
                                    "Amazon S3 Standard":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill" viewBox="0 0 16 16"><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/></svg>',
                                    "Disk":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-archive-fill" viewBox="0 0 16 16"><path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path><title>Archived</title></svg>' },
      openButtonsBrowse:false,
      configuredButtonsArray: [],
      selectedButtonComponent:null,
      configuredButtons:{}
    };
  },
  components:{
    VideoPlayer: VideoPlayer,
    "tag-metadata": tagMetadataComponent,
    "cancel-icon": CancelIcon,
    customAudioPlayer,
    confirmMessageDialog,
    ThumbnailCrop,
    ButtonsBrowse,
    ConfigureButtons,
    TagMetadataCommonComponent
  },
  
  // just coping and pasting from code review, on behalf of rashmi
   // watch:{
  //       assetDetails(newVal, oldVal){// eslint-disable-line no-unused-vars
  //           if (this.getLowresPath(newVal) != this.getLowresPath(oldVal)){
  //             if(newVal.mime_type.startsWith("video")){
                
  //                   this.videoOptions.sources = [{
  //                       src:this.getLowresPath(newVal),
  //                       type: "video/mp4"
  //                   }]
  //                   if (this.controller.player){
  //                       this.controller.restartPlayer(this.videoOptions.sources[0])
  //                   }
  //             }else if(newVal.mime_type.startsWith("audio")){
  //               if (this.getAudiowaveform(newVal) != this.getAudiowaveform(oldVal)){
  //                   this.audioUrl = this.getAudiowaveform(newVal)
  //                   document.getElementById("audio-player-id").load(); 
  //               }
  //           }
  //           }
  //       }
  //   },

  computed:{
    ...mapGetters("users",["getLoggedInUserType"]),
    getAudioParentAsset(){
       if(this.fileInfo && this.fileInfo.asset_type == 'subclip' && Object.prototype.hasOwnProperty.call(this.fileInfo,'markers') 
           && Object.prototype.hasOwnProperty.call(this.fileInfo.markers,'mime_type') && this.fileInfo.markers.mime_type == 'audio'){
          return this.audioPlayerFileInfo;
       }
       return this.fileInfo;
    },
    getImageURL(){
      if(this.cropThumbnailURL) return this.cropThumbnailURL;
      if(this.activeThumbnail === 'primaryThumbnail'){
          return this.selectedConvasPrimaryImage;
      }else{
         return this.selectedConvasSecondaryImage;
      }
    },
    getScreenType(){
      if(this.isTypeCatalog){
        if(this.parentRouteInfo && this.parentRouteInfo.name == 'assets-projects'){
         return'Sub-projects'
        }
        return "Tag Metadata-Catalog";
      }
      return "Tag Metadata";
    },
    isTypeCatalog(){
      try {
            if('asset_type' in this.assetDetails){
              return ["catalog"].includes(this.assetDetails.asset_type)
            }
        } catch (err) {
            console.error(`[isTypeCatalog][folder][Error while checking folderType-${err}]`)
        }
        return false
    },
    isAudioFile(){
        try {
            if('mime_type' in this.assetDetails){
              return this.assetDetails.mime_type.startsWith("audio")
            }   
            
        } catch (err) {
            console.error(`[isAudioFile][files][Error while checking filetype-${err}]`)
        }
        try{
            if(this.assetDetails && Object.prototype.hasOwnProperty.call(this.assetDetails,'markers') 
              && Object.prototype.hasOwnProperty.call(this.assetDetails.markers,'mime_type')){
                return this.assetDetails.markers.mime_type == 'audio';
            }                  
          }catch (err){
              console.error(`[isAudioFile][files][Error while checking filetype-${err}]`)
         }
        return false
    },
    isVideoFile(){
          try {
            if(this.assetDetails && this.assetDetails.asset_type && this.assetDetails.asset_type == 'subclip' && !this.isAudioFile){
              return true;
            }
        } catch (err) {
            console.error(`[isVideoFile][files][1][Error while checking filetype-${err}]`)
        }
        try {
            if('mime_type' in this.assetDetails && this.assetDetails.mime_type){
              return this.assetDetails.mime_type.startsWith("video")
            }
        } catch (err) {
            console.error(`[isVideoFile][files][2][Error while checking filetype-${err}]`)
        }
        return false
    },
    isImageFile(){

        try {
            if('mime_type' in this.assetDetails){
              return this.assetDetails.mime_type.startsWith("image")  ||  this.assetDetails.mime_type.startsWith("doc")
            }
        } catch (err) {
            console.error(`[isImageFile][files][Error while checking filetype-${err}]`)
        }
        return false
    },
    selectedAssetInfo(){
      return {assetDetailsFromParent:this.assetDetails}
    },
    startUpInfo:{
      get(){
          return this.$store.state.startUpData.startUpDataDetails;
      }
    },
...mapGetters("users",["getLoggedInUserPrivilege","getLoggedInUserId"])
  },

  mounted(){
    try{
      this.playerListener();
    }catch(e){console.log('e:',e)}
  },
  methods: {
    handleTagmetadataKeyBoardShortcuts(event){
        let keyCode = event.keyCode || event.which;
        let pressedElement = String(event.target.nodeName).toLowerCase();
        if(pressedElement == 'input' || pressedElement == 'textarea' || pressedElement == 'select' ) return true;
        let videoAudioRef = null;
        if(this.isVideoFile){
            videoAudioRef = this.$refs.videoPlayerRef.$el.querySelector('video');
        }

        if(this.isAudioFile){
            videoAudioRef = this.$refs.audioPlayerRef.$el.querySelector('audio');
        }
          
        if(keyCode === 32){ //spacebar
            event.preventDefault(); // don't allow to scroll
            if(videoAudioRef && videoAudioRef.paused){
                this.isPlaying = true;
                videoAudioRef.play()
            }else{
                this.isPlaying = false;
                videoAudioRef.pause();
            }
        }

    },
    //--------------Buttons Configuration---------------------
    clickToOpenButtonsBrowse(componentId){
      let payload = {params:{}};
      payload.params['context'] = 'Asset';
      this.getConfiguredButtonsInSettings(payload).then(data => {
        if (data.statusCode === 200) {
          this.configuredButtonsArray = data["buttons"];
          this.selectedButtonComponent = componentId;
          this.openButtonsBrowse = true;
          } else {
            this.$toast.error(data.message);
          }
      });
    },

    getPayloadToUpdateButton(){
      let payload = {params:{}};
      payload.params['asset_id'] = this.assetDetails.asset_id;
      return payload;
    },

    getComponentSpecificButton(componentId){
      return this.configuredButtons && this.configuredButtons[componentId]?this.configuredButtons[componentId] : [];
    },

    updateButtonsToComponents(payload){
        this.updateConfiguredButtonsToTheComponents(payload).then((data) => {
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
                if(data.message) {
                    this.$toast.success(data.message);
                }else{
                    this.$toast.success(this.$t("Buttons updated successfully"));
                }
                this.openButtonsBrowse = false
            } else {
                if(data.message){
                    this.$toast.error(data.message);  
                }  
                if(data.error){
                    this.$toast.error(data.error);  
                }  
            }
        });
    },   

    handleButtonClick(button) {
      let payload = {params:{}};
      payload.params["asset_id"] = this.assetDetails.asset_id || this.assetDetails._id;
      payload['_id'] = button.buttonInfo._id;
      this.configuredButtonClickAction(payload).then((data) => {
        if(data.statusCode === 200) {
          this.$toast.success(data.message);
          if (typeof button.onComplete === 'function') {
            button.onComplete(true);
          }
        }else{
          this.$toast.error(data.message);
          if (typeof button.onComplete === 'function') {
            button.onComplete(false);
          }
        }
      })
    },

    loadTagMetadataButtons() {
        let payload = { params: {} };
        payload["params"] = {
          component_ids: JSON.stringify([
            "FA-tagmetadata_fullscreen_on_asset_headerbar",
          ]),
        };
        payload["params"]["filter_by_permissions"] = true;
        this.fetchComponentBasedConfiguredButtons(payload).then((data) => {
          if (data.statusCode === 200) {
            this.configuredButtons = data;
          } 
        });
    },

    isUserTypeAdministrator(){
      return Utils.isUserTypeAdmin(this.getLoggedInUserType);
    },
    //--------------Buttons Configuration End-----------------
    setViewMode(mode){
      this.viewMode = mode;
      try{
        localStorage.setItem(TAG_METADATA_VIEW_MODE_KEY, mode);
      }catch(e){console.log(e)}
    },
    setTranscriptData(data){
       console.log("[setTranscriptData][data]",data);
       this.transcriptObject = data;
      this.$refs.audioPlayerRef.setCurrentTime(data.media_in/1000);
      this.$refs.audioPlayerRef.playVideo();
    },
    getColorBasedOnExpiry(locationInfo,storage){
      return Utils.getAWSStorageIconColorBasedOnExpiry(locationInfo,storage)
    },
    handleAIComponentNavigation(componentType){
        this.$emit("AIComponentNavigation",componentType)
    },
    getSvgIconForStorageClass(type){
        return this.svgIconForStorageClass[type];
    },
    replaceByDefaultImage(e){
      e.target.onerror = null
      e.target.src = Utils.getNoThumbnailImg();
    },
    getMasterAssetWithSubclip(fileObj){
        return new Promise((res) => {
            this.getAssetInfoFromServer({params:{assetId:fileObj.master_asset_id}}).then((data) => {
                if(data && data.asset)
                   res(data.asset);
            })
        });
    },
    addSubclipMarkers(markinMarkoutObj){
        this.$refs.videoPlayerRef.$el.classList.add('sub-clip-markin-markout-play');
        let start = this.getMarkerValue(markinMarkoutObj.markers.start);
        let end = this.getMarkerValue(markinMarkoutObj.markers.end);
        this.addMarkersToTimeline([{time:start,name:'markin'},{time:end,name:'markout'}]);
        try{
             if(this.videoFrameCallbackID) {
                  console.log(`Cancelled old [videoFrameCallback][${this.videoFrameCallbackID}]`);
                  this.controller.player.cancelAnimationFrame(this.videoFrameCallbackID);
              }
        }catch(e){console.log(e)}
        setTimeout(()=> {
            this.addLineBetweenMarkers();
        },100);
        this.controller.player.currentTime(start);
        this.$nextTick(()=>{
            this.currentMarkoutValue = end;
            // alert('inside');
            this.controller.player.requestAnimationFrame(this.videoFrameCallback);
        });
        // this.controller.player.pause();
    },
    playSubclipMarkinMarkout(markinMarkoutObj){
         console.log(`markinMarkoutObj markinMarkoutObj`,markinMarkoutObj);
         if(this.isAudioFile){
             this.$refs.audioPlayerRef.playSubclipArea(markinMarkoutObj);
             return;
          }
          this.getMasterAssetWithSubclip(markinMarkoutObj).then((data) => {
              if(data && data.proxy_info){
                    this.videoOptions.sources = [{
                        src:this.getLowresPath(data),
                        type: "video/mp4"
                    }];
                    this.$nextTick(() => {
                        this.controller.restartPlayer(this.videoOptions.sources,()=>{
                              this.addSubclipMarkers(markinMarkoutObj);
                        });
                    });
                }
            });
      },
     handleFullScreenRequest(){
          if(document.querySelectorAll('.subclip-timeline-marker') && document.querySelectorAll('.subclip-timeline-marker').length){
              if(this.controller.player.isFullscreen()){
                  setTimeout(() => {
                      this.addLineBetweenMarkers();
                  },100);
              }else{
                  this.addLineBetweenMarkers();
              }
          }
      },
      openSubclipWindow(selectedSubclip,componentName){
        this.selectedSubclip = selectedSubclip;
        this.selectedComponent = componentName;
        if(componentName == "asset-PartialRetrieve-as-child" || componentName == "PartialRetrieve-as-child"){
          this.$router.push({
            name:componentName,
            params:{subclipId: selectedSubclip.asset_id,subclipInfo:selectedSubclip, fileInfo:Object.assign({}, this.assetDetails),parentinfo:Object.assign({forceRedirect:true},this.$route)}
          })
        }else if(componentName == "bin-sub-clips-manager-as-child" || componentName == "sub-clips-manager-as-child" || componentName == "subclip-manager-from-media-pipeline"){
          if(selectedSubclip){
            this.$router.push({
              name:componentName,
              params:{subclipId: selectedSubclip.asset_id,subclipInfo:selectedSubclip, fileInfo:Object.assign({}, this.assetDetails),parentinfo:Object.assign({forceRedirect:true},this.$route)}
            })
          }else{
            this.$router.push({
              name:componentName,
              params:{assetId:this.assetDetails._id,fileInfo:Object.assign({}, this.assetDetails),parentinfo:Object.assign({forceRedirect:true},this.$route)}
            })
          }
        }else if(['video-transcript-as-child','bin-video-transcript-as-child'].includes(componentName)){
          let fInfo = this.assetDetails
          fInfo['version_id'] = this.assetDetails.latest_version_id
          if(selectedSubclip){
            this.$router.push({
              name:componentName,
              params:{subclipId: selectedSubclip.asset_id,subclipInfo:selectedSubclip, fileInfo:Object.assign({}, fInfo),parentinfo:Object.assign({forceRedirect:true},this.$route)}
            })
          }else{
            this.$router.push({
              name:componentName,
              params:{assetId:this.assetDetails._id,fileInfo:Object.assign({}, fInfo),parentinfo:Object.assign({forceRedirect:true},this.$route)}
            })
          }
        }else{
          this.$router.push({
            name: "explorer",
          })
        }    
      },
      getFileName(fileInfo){
        return fileInfo.file_name?fileInfo.file_name:fileInfo.slug_name
      },
      getFilePath(fileInfo){
        if ("path" in fileInfo){
            return fileInfo.path
        }else{
            return this.getCategoryRoutefromId(fileInfo.category_id)
        }
      },
      setController(controller){
        this.controller = controller;
        try{
            this.controller.player.off("fullscreenchange", this.handleFullScreenRequest);
        }catch(e){console.log(e)}
        this.controller.player.on("fullscreenchange", this.handleFullScreenRequest);
      },
      showActionsOnPlayer(){
          this.actionsOnPlayer = ! this.actionsOnPlayer;
      },
      maximisePlayer(){
          this.$emit("maximisePlayer");
      },
      closeMiniPlayer(){
          this.$emit("closeMiniPlayer")
      },
      getThumbnailPath(file){
        return Utils.getThumbnailPathfromFileInfo(file)
      },
      getLowresPath(file){
        return Utils.getLowresPathfromFileInfo(file)
      },
      getAudiowaveform(file){
          return Utils.getAudiowaveformFromFileInfo(file)
      },
      getUnique(array){
      var uniqueArray = [];
      
      // Loop through array values
      for(let i=0; i < array.length; i++){
          if(uniqueArray.indexOf(array[i]) === -1) {
              uniqueArray.push(array[i]);
          }
      }
      return uniqueArray;
      },
    closeMetadataManager(){
      // this.$emit("close",true);
      if (Object.keys(this.parentRouteInfo).length!=0 && Object.keys(this.parentRouteInfo).includes("name") ){
        this.$router.replace({
          name: this.parentRouteInfo.name,
          params:this.parentRouteInfo.params,
          query:Object.assign({}, this.parentRouteInfo.query?this.parentRouteInfo.query:{}),
        })
      }else{
        this.$router.replace({
          name: "explorer",
        })
      }
    },
    humaniseSize(bytes){
        let data = Utils.humanizeSize(bytes)
        return `${data["value"]} ${data["unit"]}`
    },
    getHumanReadableDuration(duration){
      return Utils.getDurationInSeconds(duration, true)
    },
    selectCategoryforAnAsset(){
        this.$emit("selectCategoryFromBrowse");
        this.cancelMetadataDockFields()
    },
    getCategoryRoutefromId(){
      return this.route
    },
    setAssetInfo(info){
      try{
          if(this.videoFrameCallbackID) {
              console.log(`Cancelled old [videoFrameCallback][${this.videoFrameCallbackID}]`);
              this.controller.player.cancelAnimationFrame(this.videoFrameCallbackID);
          }
      }catch(e){console.log(e)}
      this.assetDetails = {}
      Object.assign(this.assetDetails, info)
      if(Object.keys(this.assetDetails).includes("custom_metadata")){
        Object.assign(this.assetDetails["custom_metadata"], this.assetDetails.custom_metadata);
      }else{
        this.assetDetails["custom_metadata"] = [];
      }     
      this.primaryThumbnailUrl = this.getThumbnailPath(this.assetDetails);
      if(this.assetDetails.proxy_info && this.assetDetails.proxy_info.hires_thumbnail){
        this.thumbnailUrl = Utils.convertToLoginIPDomainName(this.assetDetails.proxy_info.hires_thumbnail);
      }
      if(this.assetDetails.department_info) this.selectedDepartments = this.assetDetails.department_info;
      if('mime_type' in this.assetDetails && this.assetDetails.mime_type){
        if (this.assetDetails.mime_type.startsWith("video")){
            this.videoOptions.sources.push({
                  src:this.getLowresPath(this.assetDetails),
                  type: "video/mp4"
              })
        }else if (this.assetDetails.mime_type.startsWith("audio")){
          this.audioUrl = this.getAudiowaveform(this.assetDetails)
        }
      }else if(this.assetDetails && this.assetDetails.asset_type && this.assetDetails.asset_type == 'subclip'){
          this.getMasterAssetWithSubclip(this.assetDetails).then(data => {
               if(this.isAudioFile){
                   this.audioPlayerFileInfo = data;
                   this.subclipDetails = {"markers":this.assetDetails.markers};
                   this.audioUrl = this.getAudiowaveform(data)
                  return;
               }
               this.videoOptions.sources.push({
                  src:this.getLowresPath(data),
                  type: "video/mp4"
              })
              this.$refs.videoPlayerRef.restartPlayer(this.videoOptions.sources,()=>{
                   this.addSubclipMarkers(this.assetDetails);
              });
          });
      }
      this.isLoaded=true 
    },
    refreshFileInfoAndShowAsset(fileId){
      let payload = {}
      if (this.assetId && (['projects-display','catalogs-display','media-pipeline-stage'].includes(Utils.getCookieValue("context")))){
        payload.params = {assetId: this.assetId}
        this.getAssetInfoFromServer(payload).then((data) => {
          if(Utils.getCookieValue("context") == 'media-pipeline-stage' && data.message){
              this.displayMessage = data.message;
              setTimeout(() => {
                this.displayMessage = null;
              }, 10000);
          }
          this.setAssetInfo(data["asset"])
        })
      }else{
        payload.params = {fileId: fileId, metadata:true}
        this.getFileInfoFromServer(payload).then((data) => {
            this.setAssetInfo(data["file"])
        })
      }
    },
    updateBackwardValue(){
      var video = this.$refs.videoPlayerRef.$el.querySelector('video');
      if(this.currentVideoSpeed>1 && this.currentVideoSpeed <= 5){
        this.currentVideoSpeed --;
        video.playbackRate = parseInt(this.currentVideoSpeed);
      }   
    },

    updateFastwardValue(speedAction){
      var video; //= this.$refs.videoPlayerRef.$el.querySelector('video');
        if(this.isVideoFile){
            video = this.$refs.videoPlayerRef.$el.querySelector('video');
          }else{
            video = this.$refs.audioPlayerRef.getAudioPlayer();
          }
         if(speedAction == 'forward'){
                if(this.currentVideoSpeed == 0.5){
                    this.currentVideoSpeed = 1;
                }else if(this.currentVideoSpeed > 0.5 && this.currentVideoSpeed < 5){
                    this.currentVideoSpeed++
                }else if(this.currentVideoSpeed >= 5){
                    this.currentVideoSpeed = 0.5;
                }
            }
          video.playbackRate = Number(this.currentVideoSpeed);
      
    },

    forwardBackwardVideoByFrame(type){
            if (!type) {
                console.log("Invalid type");
                return false;
            }
            let video; //= this.$refs.videoPlayerRef.$el.querySelector('video');
            if(this.isVideoFile){
                video = this.$refs.videoPlayerRef.$el.querySelector('video');
              }else{
                video = this.$refs.audioPlayerRef.getAudioPlayer();
             }
            if (video) {
                let dur = video.duration; //full duration of video
                let curDur = video.currentTime; //current time of a video
                if (dur != undefined && curDur != undefined) {
                    //forward 1 second
                    if (type == "forward" && curDur < (dur + 0.04)) {
                        video.currentTime = (curDur + 0.04)
                        Utils.getExactDuationInSeconds(curDur + 0.04);
                    }

                    //backward 1 second
                    if (type == "backward" && curDur > 0.04) {
                        video.currentTime =(curDur - 0.04)
                         Utils.getExactDuationInSeconds(curDur - 0.04);
                    }
                }
            }
    },

     forwardBackwardVideoBy1Sec(action) {
        if (!action) {
            console.log("Invalid action");
            return false;
        }
        let video; //this.$refs.videoPlayerRef.$el.querySelector('video');
        if(this.isVideoFile){
          video = this.$refs.videoPlayerRef.$el.querySelector('video');
        }else{
          video = this.$refs.audioPlayerRef.getAudioPlayer();
        }
        if (video) {
            let dur = video.duration; //full duration of video
            let curDur = video.currentTime; //current time of a video
            if (dur != undefined && curDur != undefined) {
                //forward 1 second
                if (action == "forward" && curDur < (dur + 1)) {
                    video.currentTime = curDur + 1
                }
    
                //backward 1 second
                if (action == "backward" && curDur > 1) {
                   video.currentTime = curDur - 1
                }
            }
        }
    
    },

    playPauseToggle(){
        if(this.isAudioFile){
            if(this.$refs.audioPlayerRef.getAudioPlayer().paused){
                this.$refs.audioPlayerRef.getAudioPlayer().play();
                this.isPlaying = true;
            }else{
                this.$refs.audioPlayerRef.getAudioPlayer().pause();
                this.isPlaying = false;
            }
            return;
        }
        let video = this.$refs.videoPlayerRef.$el.querySelector('video');
        if(video.paused){
            video.play();
            this.isPlaying = true;
            // video.playbackRate = 1;
            // this.currentVideoSpeed = 1;
        }else{
            video.pause();
            this.isPlaying = false;
            // video.playbackRate = 1;
            // this.currentVideoSpeed = 1;
        }

        try{
            window.blur();
        }catch(e){console.log(e)}
    },

    videoPlaytoggle(){
      this.playerListener();
      try{
          this.setProgressLabel(this.controller.player.duration());
      }catch(e){console.log(e)}
    },

    formatDurationHHMMSS_or_MMSS(duration) {
          return Utils.getExactDuationInSeconds(duration , this.frameRate, '.');
    },
    
    getDurationFormat(duration){
        const date = new Date(duration * 1000); // convert to milliseconds
        const hours = date.getUTCHours();
        if(hours > 0){
            return '00:00:00.00'
        }else{
            return '00:00.00'
        }
     },

    setProgressLabel(duration){
        try{
            [].forEach.call(document.querySelectorAll(`.player-current-time-division`),(el) => {
                el.remove();
            });
        }catch(e){console.log(e)}
        let progressBar = this.$refs.videoPlayerRef.$el.querySelector('.vjs-control-bar');
        let currentProgressEl = document.createElement('div');
        currentProgressEl.classList.add('player-current-time-division');
        currentProgressEl.innerHTML = `<span class="currrent-time">${this.getDurationFormat(duration)}</span> <span class="time-division-label">/</span> <span class="full-time-of-time-division">${this.formatDurationHHMMSS_or_MMSS(duration)}</span>`;
        progressBar.insertBefore(currentProgressEl,progressBar.querySelector('.vjs-fullscreen-control.vjs-control'));
    },

    playerListener(){
      let video = this.$refs.videoPlayerRef.$el.querySelector('video');
      video.addEventListener("pause", this.updatePlayerPauseAction);
         
      video.addEventListener("play",  this.updatePlayerPlayAction);
         
    },   

    updatePlayerPauseAction(){
      // let video = this.$refs.videoPlayerRef.$el.querySelector('video');
       this.isPlaying = false;
      //  video.playbackRate = 1;
      //  this.currentVideoSpeed = 1;
    },

    updatePlayerPlayAction(){
      // let video = this.$refs.videoPlayerRef.$el.querySelector('video');
      this.isPlaying =  true;
      // video.playbackRate = 1;
      // this.currentVideoSpeed = 1;
    },

    resetVideoSpped(){
      let video;
      if(this.isVideoFile){
         video = this.$refs.videoPlayerRef.$el.querySelector('video');
      }else{
         video = this.$refs.audioPlayerRef.getAudioPlayer();
      }
      video.playbackRate = 1;
      this.currentVideoSpeed = 1;
    },

    uploadThumbnail(e, type) {
    const file = e.target.files[0];
    const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB
    if (file.size > maxSizeInBytes) {
      alert('File must be 5MB or less.');
      e.target.value = '';
      return;
    }
    const reader = new FileReader();

    // Reset flags and URLs
    if (type === 'primary') {
      this.primaryCanvasImage = false;
      this.primaryThumbnailUrl = false;
      this.primaryThumbnailUrl = URL.createObjectURL(file);
    } else {
      this.secondaryCanvasImage = false;
      this.isSecondaryThumnailUrl = false;
      this.thumbnailUrl = URL.createObjectURL(file);
    }

    reader.onloadend = () => {
      const imageData = reader.result;
      if (type === 'primary') {
        this.uploadedCustomThumbnailForPrimaryImage = imageData;
        this.selectedConvasPrimaryImage = '';
      } else {
        this.uploadedCustomThumbnailForSecondaryImage = imageData;
        this.selectedConvasImage = '';
      }

      const payload = {
        asset_id: this.assetDetails.asset_id,
        data: {
          cust_thumb: imageData,
          proxy_type: type,
          ...(this.assetDetails.path && { path: this.assetDetails.path })
        }
      };

      this.attachUploadedOrCapturedThumbnailToFile(payload, type === 'primary' ? 'primaryThumbnail' : 'SecondaryThumnail');
    };

    reader.readAsDataURL(file);
  },

  handleCropImageData(data){
     let type = this.activeThumbnail == 'primaryThumbnail' ? 'primary' : 'secondary';
     const payload = {
      asset_id: this.assetDetails.asset_id,
      data: {
        cust_thumb: data.image,
        proxy_type: type,
        ...(this.assetDetails.path && { path: this.assetDetails.path }),
        ...(this.$refs.videoPlayerRef &&{
          frame_captured: data.frameTime
        })
      }
    };
    this.attachUploadedOrCapturedThumbnailToFile(payload, type , ()=>{
       if(this.activeThumbnail == 'primaryThumbnail'){
          this.primaryThumbnailUrl = data.image;
       }else{
         this.thumbnailUrl = data.image;
       }
       this.$nextTick(()=>{
          this.isThumbnailCaptureWithCrop = false;
       });
    });
  },

  openCaptureThumbnailDialog(type){
    this.captureFrameTimeMMS = null;
    if(type == 'primary'){
          this.cropThumbnailURL = this.primaryThumbnailUrl;//this.getThumbnailPath(this.assetDetails);
    }else{
        this.cropThumbnailURL = this.thumbnailUrl;//this.assetDetails.proxy_info.hires_thumbnail;
    }
    this.isThumbnailCaptureWithCrop = true;
  },

  captureThumbnailFromVideo() {
    const isPrimary = this.activeThumbnail === 'primaryThumbnail';
    const typeLabel = isPrimary ? 'primary' : 'secondary';
    const canvasId = isPrimary ? 'primaryThumbanilCanvas' : 'secondaryThumbnailCanvas';
    try{
        this.captureFrameTimeMMS = parseInt(this.$refs.videoPlayerRef.getCurrentPlayerTime() * 1000);
    }catch(e){console.log(e)}
    if(!isPrimary && !this.selectedConvasSecondaryImage && !this.thumbnailUrl){
      this.secondaryCanvasImage = true;
      this.isSecondaryThumnailUrl = false;
      //this.thumbnailUrl = null;
      this.$nextTick(() => {
        const video = document.querySelector('#video-player-id video');
        const canvas = document.getElementById(canvasId);

        // Set canvas size to match video’s native resolution
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        // Draw video frame onto canvas at full resolution
        canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);

        // Convert to data URL (PNG = lossless)
        const capturedImage = canvas.toDataURL("image/png");

        if (isPrimary) {
          this.cropThumbnailURL = capturedImage;
          //this.selectedConvasPrimaryImage = capturedImage;
        } else {
          this.cropThumbnailURL = capturedImage;
         // this.selectedConvasSecondaryImage = capturedImage;
        }
        
        this.$nextTick(()=>{
            this.isThumbnailCaptureWithCrop = true;
        });

        //this.customThumbnailUploadCheckboxAction(isPrimary ? 'primaryThumbnail' : 'SecondaryThumnail', true);
      });


    }else{
      const message = this.$t(`Capture new thumbnail? This will replace the existing ${typeLabel} thumbnail.`);

      this.openConfirmMessageDialog = true;
      this.confirmMessage = message;

      this.primaryButtonAction = () => {
        this.openConfirmMessageDialog = false;
        this.isChange = false;
        if (isPrimary) {
          this.primaryCanvasImage = true;
          //this.primaryThumbnailUrl = null;
        } else {
          this.secondaryCanvasImage = true;
          this.isSecondaryThumnailUrl = false;
          //this.thumbnailUrl = null;
        }

        this.$nextTick(() => {
          const video = document.querySelector('#video-player-id video');
          const canvas = document.getElementById(canvasId);

          // Set canvas size to match video’s native resolution
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;

          // Draw video frame onto canvas at full resolution
          canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);

          // Convert to data URL (PNG = lossless)
          const capturedImage = canvas.toDataURL("image/png");

          if (isPrimary) {
            //this.selectedConvasPrimaryImage = capturedImage;
            this.cropThumbnailURL = capturedImage;
          } else {
            //this.selectedConvasSecondaryImage = capturedImage;
            this.cropThumbnailURL = capturedImage;
          }
          
        this.$nextTick(()=>{
            this.isThumbnailCaptureWithCrop = true;
        });

        //this.customThumbnailUploadCheckboxAction(isPrimary ? 'primaryThumbnail' : 'SecondaryThumnail', true);
      });
      };

      this.secondaryButtonAction = () => {
        this.openConfirmMessageDialog = false;
      };
    }
  },

  updateGeneratedThumbnail(thumbnailType) {
    this.activeThumbnail = thumbnailType;
    this.customThumbnailUploadCheckboxAction(thumbnailType);
  },

  customThumbnailUploadCheckboxAction(type) {
    this.activeThumbnail = type;

    const isSecondary = type === "SecondaryThumnail";
    const selectedImage = isSecondary ? this.selectedConvasSecondaryImage : this.selectedConvasPrimaryImage;

    const payload = {
      asset_id: this.assetDetails.asset_id,
      data: {
        cust_thumb: selectedImage,
        proxy_type: isSecondary ? 'secondary' : 'primary',
        ...(this.assetDetails.path && { path: this.assetDetails.path }),
        ...(this.$refs.videoPlayerRef?.getCurrentPlayerTime && {
          frame_captured: parseInt(this.$refs.videoPlayerRef.getCurrentPlayerTime() * 1000)
        })
      }
    };

    this.attachUploadedOrCapturedThumbnailToFile(payload, type);
  },

  attachUploadedOrCapturedThumbnailToFile(payload, type , callback = null) {
    this.attachCustomThumbnailToSoftSubclip(payload).then((data) => {
      if (Utils.isAcceptedStatusCode(data.statusCode)) {
        if(callback && typeof callback == 'function') callback(data);
        this.$toast.success("Updated");
        //this.activeThumbnail = type;
      } else {
        this.$toast.error("Failed");
        this.activeThumbnail = "primaryThumbnail";
      }
    });
  },

  updateAssetDeatils(assetDetailsVal){
    if(assetDetailsVal && Object.keys(assetDetailsVal).length>0){
       this.assetDetails = assetDetailsVal;
    }
  },
  
    handleFileUpdateNotification(notification){
    notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
    if(notification.message){
        let path = notification.message.path
        let parent_path = notification.message.parent_path
        if (this.assetDetails.path == path){
          if('mime_type' in this.assetDetails && this.assetDetails.mime_type){
            if (this.assetDetails.mime_type.startsWith("video")){
                Object.assign(this.assetDetails, notification.message)

                this.videoOptions.sources = [{
                        src:this.getLowresPath(notification.message),
                        type: "video/mp4"
                    }]
                // if (this.controller.player){
                //     this.controller.restartPlayer(this.videoOptions.sources[0])
                // }
            }else if (this.assetDetails.mime_type.startsWith("audio")){
                this.audioUrl = this.getAudiowaveform(this.assetDetails)
            }else if (this.assetDetails.mime_type.startsWith("image")){
                Object.assign(this.assetDetails, notification.message)
            }
          }
            console.log(`[handleFileUpdateNotification][AssetDetails][File(${path}) updated in path->${parent_path}]`)
        }

        if('asset_id' in notification.message && this.assetDetails.asset_id == notification.message.asset_id){
          this.$set(this.assetDetails, "custom_metadata", notification.message.custom_metadata)
        }
        }
    },
    handleConfiguredButtons(notification) {
      notification =
        notification.detail && Object.keys(notification.detail).length
          ? notification.detail
          : notification;

      const messageInfo = notification.message;

      if (
        notification.message_type === "COMPONENT_BUTTONS_UPDATED" &&
        messageInfo &&
        messageInfo.component_id ===
          "FA-tagmetadata_fullscreen_on_asset_headerbar"
      ) {
        this.$set(
          this.configuredButtons,
          messageInfo.component_id,
          Array.isArray(messageInfo.buttons_info)
            ? [...messageInfo.buttons_info]
            : []
        );
      }
    },
    handleFileArchivedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length != 0 ? notification.detail : notification;
      const messageInfo = notification.message;

      if(notification.message_type !== "FILE_ARCHIVED" || !messageInfo){
        return;
      }

      const isCurrentAsset =
        (messageInfo.asset_id && messageInfo.asset_id === this.assetDetails.asset_id) ||
        (messageInfo.path && messageInfo.path === this.assetDetails.path);

      if(isCurrentAsset){
        this.$set(this.fileInfo, "archived", messageInfo.archived);
        this.$set(this.assetDetails, "archived", messageInfo.archived);
      }
    },
    registerforWebsocketNotifications(){
      this.addWSEventListener({eventname:[NotifierConstants.fileModifiedNotification, NotifierConstants.assetModifiedNotification], callback:this.handleFileUpdateNotification,parent:"TagMetadata"})
      this.addWSEventListener({
              eventname:["COMPONENT_BUTTONS_UPDATED"],
              callback:this.handleConfiguredButtons,
              parent: "TagMetadata"});
      this.addWSEventListener({
        eventname:["FILE_ARCHIVED"],
        callback:this.handleFileArchivedNotification,
        parent: "TagMetadata"});
    },
    unRegisterforWebsocketNotifications(){
      this.removeWSEventListener({eventname:[NotifierConstants.fileModifiedNotification, NotifierConstants.assetModifiedNotification], callback:this.handleFileUpdateNotification,parent:"TagMetadata"})
      this.removeWSEventListener({
          eventname:["COMPONENT_BUTTONS_UPDATED"],
          callback:this.handleConfiguredButtons,
          parent: "TagMetadata"});
      this.removeWSEventListener({
        eventname:["FILE_ARCHIVED"],
        callback:this.handleFileArchivedNotification,
        parent: "TagMetadata"});
    },
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapActions("files", ["getFileInfoFromServer"]),
    ...mapActions("tags", ["getTagsOnAutocomplete"]),
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapActions("assets", ["getAssetInfoFromServer","updateAssetInfo"]),
    ...mapActions("assets",["getCategoryTreefromId"]),
    ...mapActions("upload",["attachCustomThumbnail","attachCustomThumbnailToSoftSubclip"]),
    ...mapActions("buttons",["fetchComponentBasedConfiguredButtons","getConfiguredButtonsInSettings","updateConfiguredButtonsToTheComponents","configuredButtonClickAction"])
  },
  beforeDestroy(){
    window.removeEventListener('keydown', this.handleTagmetadataKeyBoardShortcuts);
    this.unRegisterforWebsocketNotifications();
     try{
        if(this.videoFrameCallbackID) {
            console.log(`Cancelled old [videoFrameCallback][${this.videoFrameCallbackID}]`);
            this.controller.player.cancelAnimationFrame(this.videoFrameCallbackID);
        }
    }catch(e){console.log(e)}

    let video = this.$refs.videoPlayerRef.$el.querySelector('video');
    video.removeEventListener("pause", this.updatePlayerPauseAction); 
    video.removeEventListener("play",  this.updatePlayerPlayAction);
  },
  async created(){
    window.addEventListener('keydown', this.handleTagmetadataKeyBoardShortcuts);
    Object.assign(this.parentRouteInfo, this.$route.params.parentinfo?this.$route.params.parentinfo:{})
    Object.assign(this.fileInfo, this.$route.params.selectedFileInfo?this.$route.params.selectedFileInfo:{})
    this.fileId = this.fileInfo.file_uid
    if (Object.keys(this.fileInfo).length == 0){
      let data = await this.getAssetInfoFromServer({params:{assetId:this.$route.params.assetId}})
      this.assetId = this.$route.params.assetId
      Object.assign(this.fileInfo, data.asset);
      this.fileId = this.fileInfo.file_uid
    }
    this.isLoaded=false
    if ("asset_id" in this.fileInfo){
      this.assetId = this.fileInfo.asset_id
    }else{
      this.assetId = this.fileInfo._id;
    }

    this.refreshFileInfoAndShowAsset(this.fileInfo.file_uid) 
    this.registerforWebsocketNotifications();
    this.loadTagMetadataButtons();
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
$border-color: 1px solid #4a4a4a;
$border-color-only:#4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$none-text-color:#4f4f4f;
$input-field-padding:.375rem 10px;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555;
$tags-background-color:#282d31;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$metadata-border-color-on-hover: #5a5a5a;
$readOnly-bg-color: #1e2326 !important;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;

.metadata-dock-ul{
  margin-bottom:0px;
}

.metadata-dock-ul li {
  display: inline-block;
  width: 100%;
  padding: 7px;
  border: $border-color;
  border-radius: 4px;
  margin: 4px 8px;
  width: 96%;
  position: relative;
  background:$primary-background;
  .key-style {
    color: $dull-text-color;
    width: auto;
    text-align: start;
    font-size: 14px;
    padding-inline-start: 5px;
    padding-inline-end: 5px;
    margin-top: 3px;
  }
  .value-style {
    color: $text-color;
    width: 97%;
    text-align: start;
    padding-top: 3px;
    padding-bottom: 3px;
    padding-inline-end: 5px;
    padding-inline-start: 0px;
    user-select: text !important; 
    cursor:text;
    .slug-ellipsis {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
    }
    .save-cancel-icon{
      position:relative;
      top:10px;
      inset-inline-start:5px;
      color:#fff;
      cursor:pointer;
    }
    .browse-icon{
      color:#636363 !important;
    }
  }
}

.li-style-change{
  background: $metadata-border-color-on-hover !important;
}

.readonlyDiv{
  background: $readOnly-bg-color;
}

.readonly-field{
  color:$dull-text-color;
  font-size:12px;
}
.folder-modal{
    width: 70vw;
    max-width:70%;
}
.file-modal{
    width: 100vw;
    max-width:100%;
}
.modal-dialog {
    margin: 0;
    height: 100vh;
    padding: 0;
  }
 
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-background-color;
    .modal-body{
      background: $primary-background;
      height:300px;
      padding: 0px 0px 0px 0px;
      display:inline-flex;
      width:100%;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
  background: #00000094;
  overflow:unset !important;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.on-hover-icons{
  visibility: hidden;
  color: #999 !important;
  background: $bg-color-on-hover;
  min-width: 30px;
  width: auto;
  border-radius: 4px;
  position: absolute;
  top: 0px;
  inset-inline-end: 0px;
  padding: 0px 5px;
  line-height: 1;
  border: $border-color;
  margin-inline-start: 8px;
  border: unset;
  --saf-0: rgba(var(--sk_foreground_low,29,28,29),0.13);
  box-shadow: 0 0 0 1px var(--saf-0),0 1px 3px 0 rgba(0,0,0,.08);
  display: flex;
  padding: 2px;
  border-radius: 0.375em;
  height: 35px;
  svg{
      margin:2px;
      background: #d1d2d31a;
      padding: 4px;
      height: 28px;
      width: 28px;
      border-radius: 4px;
      margin-inline-end: 5px;
      fill: $text-color !important ;
  }
  svg:hover{
      background: #fdfeff54;
  }
}

.btn{
    font-size:14px !important;
    height:100%;
}

/* width */
  ::-webkit-scrollbar {
    width: 8px;
    height:8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background !important;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $bg-color-on-hover !important;
  }


.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}

.row{
  margin:-12px !important;
  margin-inline-start:0px !important;
}


.metadata-fields{
  background: $primary-background;
  border-inline-start: $secondary-border-color !important;
  overflow: auto;
  height: 100%;
}

.modal-footer{
  justify-content: start;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    align-items: unset;
    .modal-title{
      color:$text-color;
      padding:3px;
    }
}

.modal-header .close {
    margin: 0px !important;
    padding:0px !important;
}

ul{
    list-style-type: none;
}

.activeTag{
    color: $active-blue !important;
}

.editIcon {
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 7%;
    top: 45%;
}

.aboutField{
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 1%;
    top: 45%;
}
.input-fields {
  border: none !important;
  min-width: 250Px;
  border-bottom: 1px solid $active-blue !important;
  padding-inline-start:5px;
  padding-top: 3px;
  height:38px;
}

.text-light{
  color: #b6b6b6 !important;
}

#palyer_icons_wrapper{
    width: 100%;
    align-items: center;
    height: 45px;
    margin-top: 5px;
    ul{
      display: inline-flex;
      margin-bottom: 0px !important;
      float:inline-start;
      li{
        display: inline-flex;
        height: 40px;
        margin-inline-end: 10px;
        padding: 0px !important;
        width: 45px;
        color: #bcbcbc;;
      }
    }
    .fast-forward-div, .fast-backward-div{
        width: 45px;
        height: 40px;
        display: inline-flex;
        border:1px solid #6c757d;
        color: #bcbcbc;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        margin-inline-end: 6px;
        svg{
          margin-top:0px;
          width:20px;
          height:20px;
          margin-inline-end: 5px;
          fill: #6c757d;
        }
    }
    .fast-forward-div:hover, .fast-backward-div:hover{
      background-color: #6c757d;
      border-color: #4a4a4a;
      svg{
        fill: #eee;
      }
    }  

    .active-speed{
      border-color: $active-blue;
      color: $active-blue;
    }

    .active-speed:hover{
      color:#eee !important;
    }  

    .reset-btn{
      width: 70px;
      height: 40px;
      display: inline-flex;
      border:1px solid #6c757d;
      color: #b7b7b7;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      margin-inline-end: 6px;
      float:inline-end;
    }

    .reset-btn:hover{
      background-color: #6c757d;
      border-color: #4a4a4a;
      color:#eee;
    }  
}

.comm-forward-icon[disabled]{
    cursor: not-allowed;
    color: #868686;
    border-color: #4c4c4c !important;
    svg{
      fill:#54585c;
    }
}

.comm-forward-icon[disabled]:hover{
    cursor: not-allowed;
    background-color: #393939 !important;
    color: #393939;
    border-color: #4c4c4c !important;
    svg{
      fill: #989898 !important;
    }
}

::v-deep{
.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
        background: $primary-background;
        border-bottom: $border-color;
    }
.theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover {
    background:$primary-background;
}
.theme--light.v-chip {
    border-color:#3a3a3a !important;
    color:$text-color;
}

.theme--light.v-chip:not(.v-chip--active) {
    background: $primary-background;
}

.v-list-item--link:before{
  background-color:$primary-background;
}
.vjs_video_3-dimensions, .video-js{
    height:325px !important;
    width:100% !important;
}

#video-player-id{
  .video-js{
      height:100% !important;
      width:100% !important;
  }
}

  .sub-clip-markin-markout-play .video-js .vjs-play-progress {
      background-color: #28cfd8;
  }
  .sub-clip-markin-markout-play .video-js .vjs-play-progress:before {
      font-size: 1.8em!important;
      z-index: 99!important;
      top: -0.43333333333em;
      color: #28cfd8;
  }
  .vjs-sub-clip-marker
  {
    position: absolute;
    background: #ea4863;
    width: 3px;
    height: 18px;
    top: -7px;
    z-index: 30;
    margin-inline-start: -3px;
    border-radius: 3px;
    font-size: 14px;
    font-family: "Roboto", Arial, sans-serif !important;
  }
  .sub-clip-markin-markout-play .vjs-control-bar{
    display: flex !important;
    opacity:1 !important;
  }

  .player-current-time-division{
      width: auto !important;
  }

}

.assets-details-in-metadata-manager{
    overflow:auto;
    margin-top:5px;
    ul{
      height:100%;
      overflow: auto;
      margin:0px !important;
    }
}

.thumbanils-display{
  height:143px;
  display:inline-flex;
  padding-inline-start: 8%;
  .generated-thumbails,.custom-thumbanil{
      height: 120px;
      width: 180px;
      border: $border-color;
      margin-inline-end: 10px;
      border-radius: 5px;
      position:relative;
      padding:3px;
    }
  .custom-thumbanil{
    position:relative;
    align-items: center;
    justify-content: center;
    color: $secondary-text-color;
    display: flex;
  }
}


.generated-thumbails:hover ,.custom-thumbanil:hover{
  .on-hover-icons{
    visibility: visible;
  }
}

.applyborder{
  border: 3px dotted $secondary-text-color !important;
  border-radius: 5px;
}

.applyborder:hover{
  border-radius: 5px;
  .replace-uploaded-thumbnail{
    color:#eee;
  }
}

.replace-uploaded-thumbnail{
  background: #363636a1;
  color: #eee;
  padding: 3px;
  border-radius: 7px;
  svg{
    margin-top:unset !important;
  }
}

ul{
    list-style-type: none;
    padding: 0px;
    cursor: text;
    pointer-events: all;
    user-select: text;
    li{
        display:inline-flex;
        width: 100%;
        padding:7px;
        .key-style{
            color:$dull-text-color;
            width:30%;
            text-align: end;
        }
        .value-style{
            color: #b6b6b6;
            width: 70%;
            text-align: start;
            padding-inline-start:5px !important;
            user-select: text !important; 
            cursor:text;
        }
    }
}

.change-thumbnail{
  position: absolute;
  border: 1px solid #4a4949;
  inset-inline-end: 19px;
  padding: 9px 10px;
  bottom: 0px;
  background: #1a1a1a;
  width: max-content;
  color:#eee;
}

.activeDiv{
  border:2px solid $active-blue !important;
  border-radius: 5px;
  img,canvas{
    opacity:1;
  }
}

.selected-thumbnail-display{
    width: 100%;
    display: inline-block;
    max-width: 50%;
    img{
        height:100%;
        // width:100%;
    }
    svg{
        float: inline-end;
        margin-top:5px;
    }
}

div.selected-thumbnail-display img[src^="data:image/svg+xml;charset=utf-8"]{
    height: 70% !important;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
}


.audio-player{
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 26px;
    inset-inline-start:0px;
}


.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}

input:focus,select:focus,textarea:focus,.multiselect__input:focus,.mx-input:focus{
    outline: none;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
}

.storage-type-icon{
  margin-inline-end:4px;
  margin-top:2px;
}

.metadata-dock-ul li .editIcon {
  visibility: hidden;
}

.metadata-dock-ul li:hover .editIcon,.metadata-dock-ul li:focus-within .editIcon {
  visibility: visible;
}
.editIcon {
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 2%;
    top: 10px;
}

.editIcon {
  visibility: hidden;
}


.config-desc{
  color: $dull-text-color;
  font-size: 15px;
  margin-top: 1px;
}

.thumbnail-type-tag{
  height: 20px;
  width: auto;
  padding: 0px 5px;
  background: green;
  position: absolute;
  bottom: 0px;
  inset-inline-end: 0px;
  font-size: 12px;
  border-top-left-radius: 5px;
  padding-top: 1px;
}
.tick-mark-on-thumbnail{
  position: absolute;
  top: 0px;
  inset-inline-start:0px;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $active-blue;
  border-bottom-right-radius: 2px;
}

.view-switch-wrapper{
  display: flex;
  align-items: center;
  margin-inline-start: auto;
  position: relative;
  top: -7px;
}

.view-switch-icon{
  cursor: pointer;
  color: #9c9c9c;
  padding: 5px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.view-switch-icon:hover{
  background: #22272b;
  color: #eee;
}

.modal-content.form-view-active{
  background: rgba(15, 22, 32, 0.75) !important;
  .modal-body{
    background: rgba(15, 22, 32, 0.75) !important;
  }
  .selected-thumbnail-display{
    background: rgba(15, 22, 32, 0.75) !important;
  }
  .assets-details-in-metadata-manager{
    background: rgba(15, 22, 32, 0.75) !important;
  }
}

.header-title-separator{
  margin-inline-start: 8px;
  margin-inline-end: 8px;
  color: $dull-text-color;
}
 
.archived-header-icon{
  vertical-align: middle;
  position: relative;
  top: -2px;
}
</style>